import React from "react";
import logo from "../logo.svg";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container-fluid">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-logo page-scroll" href="#page-top">
            <img className="navbar-logo" src={logo} alt="" />
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#header" className="page-scroll">
                Início
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Cadastro
              </a>
            </li>
            <li>
              <a href="#features" className="page-scroll">
                O que fazemos
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                Deferenciais
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
